import { render, staticRenderFns } from "./IncidentDetailBox.vue?vue&type=template&id=7a9113ae&scoped=true&"
import script from "./IncidentDetailBox.vue?vue&type=script&lang=ts&"
export * from "./IncidentDetailBox.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentDetailBox.vue?vue&type=style&index=0&id=7a9113ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9113ae",
  null
  
)

export default component.exports